// src/utils/businessDate.ts
// -----------------------------------------------------------------------------
// Canonical BUSINESS timezone for the whole app. The org is in Brisbane (QLD),
// which does NOT observe daylight saving, so this reference is a stable +10 all
// year round. The rule (John, 3 Sep 2026):
//   • Store UTC (the DB already does — `created_at` etc. are timestamptz).
//   • Display a timestamp in the VIEWER's local time (so a volunteer logging in
//     from overseas sees their own clock).
//   • Bucket / filter / report a "business day" against THIS fixed zone, so a
//     report is identical for every viewer no matter where they are.
// See docs/timezone-review-2026-09-03.md.
// -----------------------------------------------------------------------------

export const BUSINESS_TZ = "Australia/Brisbane";

// The Brisbane business day (yyyy-mm-dd) for a UTC ISO timestamp (e.g. created_at).
// Returns "" for a missing/invalid input so callers can fall back to a legacy value.
// `en-CA` formats as yyyy-mm-dd; `timeZone` pins the day to Brisbane regardless of
// the viewer's own timezone.
export function businessDay(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-CA", { timeZone: BUSINESS_TZ });
}
